<style>
@import '../../custom/css/cria-dicas.css';
</style>

<template>
  <div id="cria-profissao" class="cria-dicas" v-if="profissao !== null">
    <h1 class="title text-uppercase font-weight-bold">Criar Profissão</h1>
    <hr class="linha-amarela" />
    <div class="form-group">
      <label for="nome">Nome</label>
      <input
        type="text"
        class="form-control"
        id="nome"
        v-model="profissao.nome"
      />
    </div>
    <div class="form-group">
      <div class="btn btn-success" @click="criarProfissao()">Criar</div>
      <div class="btn btn-voltar-dicas" @click="voltarLista()">Voltar</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'cria-profissao',
  data: () => ({
    profissao: {
      nome: null,
    },
  }),
  computed: {
    ...mapGetters([
      'getTipoNotification',
      'getNotification',
      'getLoaderAction',
    ]),
    ...mapState({
      dadosUsuario: (state) => state.dadosUsuario,
    }),
  },
  methods: {
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    criarProfissao() {
      const self = this;
      this.$store.dispatch('startLoader');
      this.$store.dispatch('insertProfissao', this.profissao).then((data) => {
        setTimeout(() => {
          if (self.getTipoNotification == 1) {
            self.$store.dispatch('endLoader');
            setTimeout(() => {
              self.aviso(self.getNotification, 'success');
              setTimeout(() => {
                self.$router.push({ name: 'administrador-lista-profissoes' });
              }, 1000);
            }, 100);
          } else if (self.getTipoNotification == 3) {
            self.$store.dispatch('endLoader');
            setTimeout(() => {
              self.aviso(self.getNotification, 'danger');
            }, 100);
          }
        }, 100);
      });
    },
    voltarLista() {
      this.$router.push({
        name: 'administrador-lista-profissoes',
      });
    },
  },
};
</script>
